export const CREATE_USER = 'register/CREATE_USER';
export const CREATE_USER_SUCCESS = 'register/CREATE_USER_SUCCESS';
export const CREATE_USER_FAILURE = 'register/CREATE_USER_FAILURE';
